import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/logo_2.png'
import _imports_1 from '@/assets/images/empty.png'


const _hoisted_1 = { class: "reply-page__wrapper" }
const _hoisted_2 = {
  key: 1,
  class: "reply-page"
}
const _hoisted_3 = { class: "reply-page__card reply-page__card_type_profile profile" }
const _hoisted_4 = { class: "profile__avatar" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "profile__info" }
const _hoisted_7 = { class: "profile__name" }
const _hoisted_8 = { class: "reply-page__card reply-page__card_type_project project" }
const _hoisted_9 = { class: "project__header" }
const _hoisted_10 = { class: "project__title" }
const _hoisted_11 = { class: "project__content" }
const _hoisted_12 = { class: "project__description" }
const _hoisted_13 = {
  key: 0,
  class: "project__field project__field_type_link"
}
const _hoisted_14 = ["href"]
const _hoisted_15 = {
  key: 1,
  class: "project__field project__field_type_file"
}
const _hoisted_16 = {
  key: 2,
  class: "reply-page__empty"
}

import { onMounted, ref, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { SPreloaderDebounced, SUploaderMini, useToast } from '@synergy/ui-kit-vue3'
import axios from 'axios'
import ENV from '@/env.json'
import type { Fields, Personal } from '@/types/Portfolio/portfolio.types'
import defaultAvatar from '@/assets/images/avatar.png';



export default /*@__PURE__*/_defineComponent({
  __name: 'Root',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const toast = useToast()

const token = route.params.outer_token as string
const loading = ref(false)
const info = ref<Fields[]>([])
const personal = ref<Personal>()

const FIO = computed(() => {
  if (!personal.value) return '';
  
  const parts = [
    personal.value.last_name,
    personal.value.first_name,
    personal.value.middle_name
  ].filter(part => part && part.trim() !== '');
  
  return parts.join(' ');
});

const avatarSrc = computed(() => {
  return personal.value?.avatar_url || defaultAvatar;
});

onMounted(async () => {
  updateData()
})

async function updateData() {
  loading.value = true
  await fetchInfo()
  loading.value = false
}

async function fetchInfo(): Promise<Fields[]|void> {
  try {
    const { data } = await axios.get(`${ENV.PORTFOLIO__API_URL}/portfolio/outer/${token}`)
    info.value = data.data.map((item: Fields) => ({
      ...item,
      attached_file: item.attached_file ? {
        id: item.attached_file.id,
        name: item.attached_file.file_name,
        size: item.attached_file.file_size,
        link: item.attached_file.link,
        type: item.attached_file.mime_type,
        file_name: item.attached_file.file_name,
        file_size: item.attached_file.file_size,
        mime_type: item.attached_file.mime_type
      } : null
    }))
    personal.value = data.profile
  } catch (error: unknown) {
    console.error(error)
    toast.add({
      severity: 'error',
      summary: 'Произошла ошибка при запросе информации',
      life: 3000,
    })

    router.push({ name: 'not_found' })
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "reply-page__logo" }, [
      _createElementVNode("img", {
        alt: "",
        src: _imports_0
      })
    ], -1)),
    (loading.value)
      ? (_openBlock(), _createBlock(_unref(SPreloaderDebounced), {
          key: 0,
          "is-active": loading.value,
          delay: 1000,
          "deactivation-delay": 2000
        }, null, 8, ["is-active"]))
      : (info.value && info.value.length && !loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "reply-page__title" }, "Моё портфолио", -1)),
            _createElementVNode("section", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("img", {
                  src: avatarSrc.value,
                  alt: "Аватар",
                  class: "profile__avatar-image"
                }, null, 8, _hoisted_5)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("p", _hoisted_7, _toDisplayString(FIO.value), 1)
              ])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info.value, (value, key) => {
              return (_openBlock(), _createElementBlock("div", {
                key: key,
                class: "reply-page__item"
              }, [
                _createElementVNode("section", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("h2", _hoisted_10, _toDisplayString(value?.title), 1)
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, _toDisplayString(value.description), 1),
                    (value?.materials_link)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          _cache[0] || (_cache[0] = _createElementVNode("span", { class: "project__label" }, "Ссылка на материалы", -1)),
                          _createElementVNode("a", {
                            href: value.materials_link,
                            target: "_blank",
                            class: "project__link"
                          }, _toDisplayString(value.materials_link), 9, _hoisted_14)
                        ]))
                      : _createCommentVNode("", true),
                    (value.attached_file)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _cache[1] || (_cache[1] = _createElementVNode("span", { class: "project__label" }, "Прикреплённый файл", -1)),
                          (value.attached_file)
                            ? (_openBlock(), _createBlock(_unref(SUploaderMini), {
                                key: 0,
                                removable: false,
                                files: [value.attached_file],
                                class: "project__uploader",
                                downloadable: false
                              }, null, 8, ["files"]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_16, _cache[3] || (_cache[3] = [
            _createElementVNode("img", {
              alt: "",
              src: _imports_1
            }, null, -1),
            _createElementVNode("div", null, [
              _createElementVNode("b", null, "Портфолио недоступно")
            ], -1),
            _createElementVNode("div", { style: {"font-size":"16px"} }, "Все записи в портфолио были удалены.", -1),
            _createElementVNode("div", { style: {"font-size":"16px"} }, "Для получения актуальной информации запросите новую ссылку", -1)
          ])))
  ]))
}
}

})